<div class="chart-loader-container">
  <div class="d-flex flex-column">
    <h3 class="h3-bold primary-100">{{ headingTitle }}</h3>
    <h4 *ngIf="subtitle" class="h4-reg primary-60">{{ subtitle }}</h4>
  </div>
  <ng-container *ngIf="loadingState$ | async as loadingState">
    <!-- Loading State -->
    @if (loadingState === processingState.Loading) {
      <div class="state-overlay loading-overlay" aria-live="polite">
        <div class="loader-container">
          <img [src]="loaderImagePath" alt="Loading data" class="loader-spin" />
          <span class="loading-text">Loading data</span>
        </div>
      </div>
    }

    <!-- Error State -->
    @if (loadingState === processingState.Error) {
      <div class="state-overlay error-overlay" aria-live="assertive">
        <div class="chart-error" role="alert">
          <div class="d-flex flex-column spacing-4 error-content">
            <div class="error-title h4-bold">Error</div>
            <div class="error-hint h4-reg">
              {{ errorMessage || 'An unexpected error occurred. Please try again.' }}
            </div>
          </div>
          <!-- TODO: Add retry button in case of an error -->
          <!-- <app-secondary-btns
            class="retry-btn"
            label="Retry"
            size="small"
            IconType="">
          </app-secondary-btns> -->
        </div>
      </div>
    }

    <!-- Empty State -->
    @if (loadingState === processingState.Empty) {
      <div class="state-overlay empty-overlay" aria-live="polite">
        <div class="chart-empty">
          <div class="empty-message">{{ emptyMessage || 'No data available' }}</div>
        </div>
      </div>
    }

    <!-- Content -->
    <div class="chart-content" [class.dimmed]="loadingState !== processingState.Success">
      @if (loadingState === processingState.Success && contentTemplate) {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      }
    </div>
  </ng-container>
</div>
